export const companiesKeys = {
	all: ['companies'],
	byProspectQueryBase: (prospectQueryId) => ['companies', 'byProspectQuery', prospectQueryId],
	byProspectQuery: (prospectQueryId, { page, pageSize, orderBy, orderDir, filters = {} }) => [
		'companies',
		'byProspectQuery',
		prospectQueryId,
		page,
		pageSize,
		orderBy,
		orderDir,
		filters,
	],
	detail: (companyId) => ['companies', 'detail', companyId],
	nameSearch: (query) => ['companies', 'nameSearch', query],
	financialHistory: (companyId) => ['companies', 'financialHistory', companyId],
	events: (companyId) => ['companies', 'events', companyId],
	contacts: (companyId) => ['companies', 'contacts', companyId],
	directors: (companyId) => ['companies', 'directors', companyId],
};

export const companiesMutationKeys = {
	update: ['companies', 'update'],
	delete: ['companies', 'delete'],
	enrich: ['companies', 'enrich'],
	addToQuery: ['companies', 'addToQuery'],
};
